/**
 * Contains utilities to deal with file uploads.
 */

// The number of bytes after which Webflow will display a warning icon
export const HEAVY_BYTES = 200 * 1024;
